module.exports = __webpack_public_path__ + "static/media/4hungerPic.6b0aca6a.jpg";